module.exports = __webpack_public_path__ + "img/gk_img2.8e4e299b.png";